import React, { useState } from "react";
import { Clock3, Mail, Upload, UserRound, BookUser } from "lucide-react";
import "../../pages/EditInfo.css";
import "../../pages/AdminProfile.css";
import PasswordChangeContent from "./PasswordChangeContent";

const EditInfoContent = ({ embedded = false }) => {
  const [formData, setFormData] = useState({
    name: "superadmin",
    email: "superadmin@blackroth.in",
    timezone: "Indian/Maldives",
    biography: "",
  });
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    alert("Profile information updated successfully");
  };

  return (
    <>
      <section className={`edit-card${embedded ? " embedded" : ""}`}>
        <div className="edit-card-head">
          <h2>Account Details</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="edit-content-row">
            <div className="edit-upload-wrap">
              <label htmlFor="edit-profile-upload" className="edit-upload-circle">
                <span className="edit-upload-head">
                  <Upload size={14} />
                  Upload
                </span>
                <span className="edit-upload-help">Accepts .jpg, .jpeg, .png files</span>
              </label>
              <input id="edit-profile-upload" type="file" accept=".jpg,.jpeg,.png" hidden />
            </div>

            <div className="edit-grid">
              <label className="edit-field">
                <span className="edit-label">
                  <UserRound size={15} />
                  Name
                </span>
                <input
                  type="text"
                  value={formData.name}
                  onChange={handleChange("name")}
                  placeholder="Enter name"
                />
              </label>

              <label className="edit-field">
                <span className="edit-label">
                  <Mail size={15} />
                  Email Address
                </span>
                <input
                  type="email"
                  value={formData.email}
                  onChange={handleChange("email")}
                  placeholder="Enter email"
                />
              </label>

              <label className="edit-field">
                <span className="edit-label">
                  <Clock3 size={15} />
                  Timezone
                </span>
                <input
                  type="text"
                  value={formData.timezone}
                  onChange={handleChange("timezone")}
                  placeholder="Enter timezone"
                />
              </label>

              <label className="edit-field">
                <span className="edit-label">
                  <BookUser size={15} />
                  Biography
                </span>
                <textarea
                  rows={3}
                  value={formData.biography}
                  onChange={handleChange("biography")}
                  placeholder="Write biography"
                />
              </label>
            </div>
          </div>

          <div className="edit-actions">
            <button
              type="button"
              className="edit-btn-outline"
              onClick={() => setIsPasswordOpen(true)}
            >
              Change Password
            </button>
            <button type="submit" className="edit-btn-filled">
              Update Info
            </button>
          </div>
        </form>
      </section>

      {isPasswordOpen && (
        <div className="profile-edit-modal-overlay" onClick={() => setIsPasswordOpen(false)}>
          <div className="profile-edit-modal" onClick={(event) => event.stopPropagation()}>
            <div className="profile-edit-modal-head">
              <h3>Change Password</h3>
              <button
                type="button"
                className="profile-edit-close"
                onClick={() => setIsPasswordOpen(false)}
                aria-label="Close change password popup"
              >
                x
              </button>
            </div>
            <div className="profile-edit-modal-content">
              <PasswordChangeContent embedded />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditInfoContent;
